import React, { useRef } from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useIntl } from 'react-intl'
import { Quill } from '../../widgets/components/Input/Quill'

export const EditorComp = ({
  height,
  heightContainer,
  is_drag_source = false,
  index,
  onRichTextValueChange,
  richTextAreaValue,
}: {
  height?: any
  heightContainer?: any
  is_drag_source?: boolean
  index?: number
  onRichTextValueChange?: (richtextValue: string, index: number) => void
  richTextAreaValue?: any
}) => {
  const { formatMessage } = useIntl()

  const initialValue = useRef(richTextAreaValue || '')

  return (
    <>
      {is_drag_source ? (
        <div className='bg-white p-5'>
          <div className='d-flex'>
            <div>
              <img src={toAbsoluteUrl('/media/icons/investor-updates/threeArrow.svg')} alt='' />
            </div>
            <div>
              <p className='ps-2 font-weight-400 font-size-12 text-color'>
                {formatMessage({ id: 'Add Section' })}
              </p>
            </div>
          </div>
          <div className='editor-container'>
            <Quill height={'100'} />
            <div className='overlay'></div>
          </div>
        </div>
      ) : (
        <div className='bg-white rounded'>
          <Quill
            height={height}
            quillText={richTextAreaValue}
            setQuillText={(value: string) => {
              if (onRichTextValueChange && index !== undefined) {
                onRichTextValueChange(value, index)
              }
            }}
            aiEmailResponse={initialValue.current}
          />
        </div>
      )}
    </>
  )
}
